/* eslint-disable react-hooks/exhaustive-deps */
import {useTranslation} from "react-i18next"
import debounce from "debounce-promise"
import {taskService} from "services"
import {KlassDropAsyncPaginate, KlassDropdownAsyncProps} from "../Select"
import {useQueryClient} from "@tanstack/react-query"
import {Task, TaskSubtype} from "types/tasks"

type Props = Partial<KlassDropdownAsyncProps> & {
    componentKey?: string
    departmentId: number
}

export function TaskLibrarySelect(props: Props) {
    const {t} = useTranslation(["common"])
    const queryClient = useQueryClient()

    const loadOptions = debounce(async (search, loadedOptions) => {
        const pageSize = 10
        const page = Math.ceil(loadedOptions.length / pageSize) + 1

        const queryKey = ["task-library", search, page, props.componentKey]
        const cachedData = queryClient.getQueryData(queryKey, {exact: true})
        if (cachedData) {
            return cachedData
        }

        const params = {
            range: {
                page,
                pageSize
            },
            filter: {
                search,
                subtype: TaskSubtype.LIBRARY,
                departmentIds: [props.departmentId]
            }
        }
        const {data, total} = await taskService.getAll(params)
        const formatted = {
            options: data,
            hasMore: loadedOptions.length < total
        }

        queryClient.setQueryData(queryKey, formatted)
        return formatted
    }, 500)

    return (
        <KlassDropAsyncPaginate
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={loadOptions}
            valueKey="id"
            labelKey="name"
            getOptionLabel={(option: Task) => `[${option.code}] ${option.name}`}
        />
    )
}
